import { render, staticRenderFns } from "./addReviewOpinions.vue?vue&type=template&id=7f61824e&scoped=true&"
import script from "./addReviewOpinions.vue?vue&type=script&lang=js&"
export * from "./addReviewOpinions.vue?vue&type=script&lang=js&"
import style0 from "./addReviewOpinions.vue?vue&type=style&index=0&id=7f61824e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61824e",
  null
  
)

export default component.exports